/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Intervention_End_DateInputs */



/**
* | output |
* | --- |
* | "Intervention end date" |
*
* @param {Intervention_Plan_Intervention_End_DateInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_intervention_end_date = /** @type {((inputs?: Intervention_Plan_Intervention_End_DateInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Intervention_End_DateInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Intervention end date")
	return /** @type {LocalizedString} */ ("Date de fin d'intervention")
});